import React from "react";
import { TitledContent } from "./TitledContent";
import { defineMessage, FormattedMessage } from "react-intl";
import { useLoaderData } from "react-router-dom";
import { ListResult } from "../utils/crud";
import ldap_auth from "../descriptors/ldap_auth";
import List from "./List";
import ResourceFormButton from "./ResourceFormButton";
import LDAPTestButton from "./LDAPTestButton";

const LDAPAuthsPage: React.FC = () => {
    const data = useLoaderData() as ListResult;
    const descriptor = ldap_auth;
    const resourceName = "ldap_auth";

    return (
        <TitledContent
            title={<FormattedMessage id="ldap_auth.list" defaultMessage="List of LDAP server configs" />}
            action={
                <ResourceFormButton
                    resourceName={resourceName}
                    action="create"
                    dialogTitle={defineMessage({
                        id: "ldap_auth.create",
                        defaultMessage: "Create LDAP server config",
                    })}
                    extraButtons={[LDAPTestButton]}
                />
            }
        >
            <List
                data={data.rows}
                maxPage={Math.ceil(data.count / descriptor.listDefaults.limit)}
                header={descriptor.orders.list}
                uri={new URL(window.location.href)}
                renderers={descriptor.renderers?.list}
                fieldNameKeyFactory={(fieldName: string) => `${resourceName}.${fieldName}`}
            />
        </TitledContent>
    );
};

export default LDAPAuthsPage;
